import React from 'react'
import { List, Skeleton } from '@fs/zion-ui'

export default function SearchRecordsSkeleton(): JSX.Element {
  return (
    <List>
      <Skeleton.ListItem dense hasIcon />
      <Skeleton.ListItem dense hasIcon />
      <Skeleton.ListItem dense hasIcon />
      <Skeleton.ListItem dense hasIcon />
      <Skeleton.ListItem dense hasIcon />
      <Skeleton.ListItem dense hasIcon />
    </List>
  )
}
